<div class="quote__text">{{ data.quote }}</div>
<div class="quote__author">{{ data.author }}</div>
<div class="quote__description">{{ data.description }}</div>
